import { Component, inject, Input } from '@angular/core';
import { Deal } from 'app/models/dto/deal.model';
import { Store } from '@ngxs/store';
import { LenderUserState } from 'ng2-app/store/lender-user/lender-user/lender-user.state';
import { Observable } from 'rxjs';
import { dealStageColorClassMap } from 'ng2-app/util/deal/deal.utility';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { DealStatusDisplayPipe } from 'app/pipes/deal-status-display/deal-status-display.pipe';

@Component({
  selector: 'app-deal-status-display',
  templateUrl: './deal-status-display.component.html',
  styleUrls: ['./deal-status-display.component.scss'],
  imports: [
    CommonModule,
    DealStatusDisplayPipe,
    MatTooltipModule,
  ]
})
export class DealStatusDisplayComponent {
  dealStageColorClassMap = dealStageColorClassMap;

  @Input() deal: Deal;
  @Input() showTooltip: boolean = true;
  canSeeDealStatusRestrictions$: Observable<boolean> = inject(Store).select(
    LenderUserState.hasPermission('canSeeDealStatusRestrictions')
  );

  constructor() { }
}
